/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespMainContent_itemSearch$ref = any;
type SbRespNullSearchResults_itemSearch$ref = any;
type SbRespTradeOnApprovalPromoBanner_itemSearch$ref = any;
type SbSharedBillboardAd_itemSearch$ref = any;
type SbSharedPageBreadcrumbs_itemSearch$ref = any;
type SbSharedTitle_itemSearch$ref = any;
type SharedRespMoreWaysToBrowse_internalBuyLinks$ref = any;
export type SbRespCollectionsComponents_itemSearch$ref = any;
export type SbRespCollectionsComponents_itemSearch = {
    readonly totalResults: number | null;
    readonly pageType: string | null;
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly values: ReadonlyArray<{
            readonly urlLabel: string | null;
        } | null> | null;
    } | null> | null;
    readonly internalBuyLinks: ReadonlyArray<{
        readonly " $fragmentRefs": SharedRespMoreWaysToBrowse_internalBuyLinks$ref;
    } | null> | null;
    readonly " $fragmentRefs": SbRespNullSearchResults_itemSearch$ref & SbSharedPageBreadcrumbs_itemSearch$ref & SbSharedTitle_itemSearch$ref & SbSharedBillboardAd_itemSearch$ref & SbRespTradeOnApprovalPromoBanner_itemSearch$ref & SbRespMainContent_itemSearch$ref;
    readonly " $refType": SbRespCollectionsComponents_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespCollectionsComponents_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isTrade",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalResults",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "pageType",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "appliedFilters",
            "storageKey": null,
            "args": null,
            "concreteType": "SearchBrowseParsedParam",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "values",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SearchBrowseParsedParamValue",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "urlLabel",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "internalBuyLinks",
            "storageKey": null,
            "args": null,
            "concreteType": "InternalBuyLinkType",
            "plural": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "SharedRespMoreWaysToBrowse_internalBuyLinks",
                    "args": null
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "SbRespNullSearchResults_itemSearch",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedPageBreadcrumbs_itemSearch",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedTitle_itemSearch",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedBillboardAd_itemSearch",
            "args": null
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isTrade",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "SbRespTradeOnApprovalPromoBanner_itemSearch",
                    "args": null
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "SbRespMainContent_itemSearch",
            "args": null
        }
    ]
} as any);
(node as any).hash = '4eea2635cd4e9e7f3c2a7b585903530d';
export default node;
